/* /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/selectors.coffee */
(function () {
var hasProp = {}.hasOwnProperty;

hubspot.define('hubspot.reagan.selectors', [], function() {
  var Selectors;
  return Selectors = (function() {
    function Selectors(params) {
      var failure, name, ref, ref1, success, toFind, value;
      success = (ref = params.success) != null ? ref : params;
      failure = (ref1 = params.error) != null ? ref1 : {};
      this.successesRemainining = 0;
      if (typeof (success != null ? success.length : void 0) === 'number') {
        this.successesRemainining = success.length;
      } else if (success != null) {
        this.successesRemainining = Object.keys(success).length;
      }
      toFind = {};
      for (name in success) {
        if (!hasProp.call(success, name)) continue;
        value = success[name];
        if (toFind[name] == null) {
          toFind[name] = {
            name: name,
            found: false
          };
        }
        toFind[name].successSelector = value;
      }
      for (name in failure) {
        if (!hasProp.call(failure, name)) continue;
        value = failure[name];
        if (toFind[name] == null) {
          toFind[name] = {
            name: name,
            found: false
          };
        }
        toFind[name].failureSelector = value;
      }
      this.toFind = toFind;
    }

    Selectors.prototype.isFinished = function() {
      return this.successesRemainining === 0 || this.getToCheck().length === 0;
    };

    Selectors.prototype.found = function(key, success) {
      if (success == null) {
        success = true;
      }
      if (this.toFind[key]) {
        this.toFind[key].found = true;
        if (success) {
          this.toFind[key].succeeded = true;
          return this.successesRemainining--;
        } else {
          return this.toFind[key].failed = true;
        }
      }
    };

    Selectors.prototype._get = function(type, value) {
      if (type == null) {
        type = 'found';
      }
      if (value == null) {
        value = true;
      }
      return Object.keys(this.toFind).map((function(_this) {
        return function(key) {
          return _this.toFind[key];
        };
      })(this)).filter(function(val) {
        return (val != null ? val[type] : void 0) === value;
      });
    };

    Selectors.prototype.getToCheck = function() {
      return this._get('found', false);
    };

    Selectors.prototype.getFound = function() {
      return this._get('found');
    };

    Selectors.prototype.getSucceeded = function() {
      return this._get('succeeded');
    };

    Selectors.prototype.getFailed = function() {
      return this._get('failed');
    };

    return Selectors;

  })();
});
}());




//////////////////
// WEBPACK FOOTER
// ../~/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!../~/bender-webpack/lib/no-parse-loader.js!../~/bender-webpack/lib/sporks/loader.js!/usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/selectors.coffee
// module id = 595
// module chunks = 